import { Updater } from '@tanstack/react-form/remix';
import * as React from 'react';

import { cn } from '../../../../utils';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	className?: string;
	handleChange?: (updater: Updater<string>) => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	({ className, handleChange, ...props }, ref) => {
		return (
			<input
				className={cn('mr-3 text-success', className)}
				ref={ref}
				type='checkbox'
				onChange={(e) => handleChange?.(() => (e.target.checked ? 'true' : 'false'))}
				{...props}
			/>
		);
	}
);
